import * as React from 'react';
import { getConfig } from '@cian/config/browser';

/**
 * Создает коллбэк, позволяющий определить, в каком месте рендерить промо-баннер
 * В зав-ти от RS настройки, баннер можно поставить в начало, конец, или любое место в середине листинга
 * */
export const useShouldRenderBanner = (listItemsLength: number) => {
  const config = getConfig();
  const promoBannerPosition = config.get<number>('realtorsPromoBannerPosition.value');

  return React.useMemo(() => {
    return (index: number, isLast?: boolean): boolean => {
      if (promoBannerPosition === listItemsLength) {
        return Boolean(isLast && index === listItemsLength - 1);
      }

      return !isLast && index === promoBannerPosition;
    };
  }, [listItemsLength, promoBannerPosition]);
};
